import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { createModules, createSubscription, fetchAllSubscription, fetchDaycareEnquirey, fetchModules, fetchSubscription, removeModules, removeSubscription, updateDaycareEnquirey, updateModules, updatePendingDaycareEnquirey, updateSubscription } from "../../service/api";


export const getEnquiry = createAsyncThunk(
    "enquiry/getAll",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchDaycareEnquirey(params)
            console.log("fetch enquiry", response)
            return response.data.data
        } catch (error) {
            return rejectWithValue(err.response?.data || err.message)
        }
    }
)


export const editEnquiry = createAsyncThunk(
    "enquiry/edit",
    async (newData, { rejectWithValue }) => {
        try {
            const response = await updateDaycareEnquirey(newData)
            if (response.status === 201) {
                console.log("edit enquiry", response)
            }
        } catch (error) {
            console.log(error)
            return rejectWithValue(error.response.data || error.message)
        }
    }
)




export const editPendingStatusEnquiry = createAsyncThunk(
    "enquiry/pendignEdit",
    async (newData, { rejectWithValue }) => {
        try {
            const response = await updatePendingDaycareEnquirey(newData)
            if (response.status === 201) {
                console.log("edit enquiry", response)
            }
        } catch (error) {
            console.log(error)
            return rejectWithValue(error.response.data || error.message)
        }
    }
)



const enquirySlice = createSlice({
    name: "enquiry",
    initialState: {
        enquiryList: [],
        isLoading: false,
        actionLoader: false,
        error: null,
        totalPage: 0,
        current: 1,
        limit: 10,
        searchParams: "",
        enquiryType: "",
        status: "",
    },
    reducers: {
        setPagination: (state, action) => {
            state.current = action.payload;
        },
        setTypeFilter: (state, action) => {
            state.enquiryType = action.payload
        },
        setStatusFilter: (state, action) => {
            state.status = action.payload
        },
        setSearchParams: (state, action) => {
            state.searchParams = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getEnquiry.pending, (state) => {
                state.isLoading = true,
                    state.error = null
            })
            .addCase(getEnquiry.fulfilled, (state, action) => {
                state.isLoading = false;
                state.enquiryList = action.payload.data;
                state.totalPage = action.payload.totalPage
            })
            .addCase(getEnquiry.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload
            })

            // PUT
            .addCase(editEnquiry.pending, (state, action) => {
                state.actionLoader = true;
            })
            .addCase(editEnquiry.fulfilled, (state, action) => {
                state.actionLoader = false;
            })
            .addCase(editEnquiry.rejected, (state, action) => {
                state.actionLoader = false;
                state.error = action.payload;
            })


            // PUT PEINDING STATUS
            .addCase(editPendingStatusEnquiry.pending, (state, action) => {
                state.actionLoader = true;
            })
            .addCase(editPendingStatusEnquiry.fulfilled, (state, action) => {
                state.actionLoader = false;
            })
            .addCase(editPendingStatusEnquiry.rejected, (state, action) => {
                state.actionLoader = false;
                state.error = action.payload;
            })


    }
})
export const { setPagination, setSearchParams, setTypeFilter, setStatusFilter } = enquirySlice.actions;
export default enquirySlice.reducer;